import React from 'react';

// Ficha de cliente para tenants de tipo "Inmobiliaria".
// Estado controlado por FichaCliente (perfil = datos de clientes, ficha = clientes_ficha_inmobiliaria).

export const esInmobiliaria = (tipoNegocio) => /inmobili/i.test(tipoNegocio || '');

export const ESTADOS_CON_CONYUGE = ['casado', 'union_hecho'];

export const DOCUMENTOS_INMO = [
  { key: 'cedula_cliente',     label: 'Copia de cédula (cliente)' },
  { key: 'cedula_conyuge',     label: 'Copia de cédula (cónyuge)' },
  { key: 'certificado_voto',   label: 'Certificado de votación' },
  { key: 'roles_pago',         label: 'Roles de pago (3 últimos)' },
  { key: 'mecanizado_iess',    label: 'Mecanizado de aportes IESS' },
  { key: 'planilla_servicio',  label: 'Planilla de servicio básico' },
  { key: 'estados_cuenta',     label: 'Estados de cuenta (3 meses)' },
  { key: 'ruc_sri',            label: 'RUC / declaraciones SRI' },
  { key: 'precalificacion',    label: 'Precalificación bancaria / BIESS' },
];

const REF_VACIA = { nombre: '', telefono: '', relacion: '', direccion: '' };

const SECCIONES = {
  blue:   { color: '#1d4ed8', bg: '#eff6ff' },
  violet: { color: '#6d28d9', bg: '#f5f3ff' },
  green:  { color: '#047857', bg: '#ecfdf5' },
  amber:  { color: '#b45309', bg: '#fffbeb' },
  rose:   { color: '#be123c', bg: '#fff1f2' },
};

const gridSt = { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '1rem' };

function Seccion({ tag, color, titulo, hint, children, first }) {
  const c = SECCIONES[color];
  return (
    <div style={{ borderTop: first ? 'none' : '1px solid #f3f4f6', paddingTop: first ? 0 : '1.25rem', marginBottom: '1.25rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
        <span style={{
          fontSize: '0.68rem', fontWeight: '700', letterSpacing: '0.06em', textTransform: 'uppercase',
          padding: '0.2rem 0.6rem', borderRadius: '6px', background: c.bg, color: c.color,
        }}>{tag}</span>
        <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: '700', color: '#374151' }}>{titulo}</h3>
        {hint && <span style={{ fontSize: '0.78rem', color: '#9ca3af' }}>{hint}</span>}
      </div>
      {children}
    </div>
  );
}

function Referencias({ items, onChange, labels, agregarTxt, inputSt, Label }) {
  const set = (i, k, v) => onChange(items.map((r, j) => j === i ? { ...r, [k]: v } : r));
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.65rem' }}>
      {items.length === 0 && (
        <p style={{ margin: 0, fontSize: '0.85rem', color: '#9ca3af' }}>Sin referencias registradas.</p>
      )}
      {items.map((r, i) => (
        <div key={i} style={{
          display: 'flex', flexWrap: 'wrap', gap: '0.65rem', alignItems: 'flex-end',
          background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '0.75rem',
        }}>
          <div style={{ flex: '1.3 1 180px', minWidth: 0 }}><Label text={labels[0]}><input style={inputSt} value={r.nombre} onChange={e => set(i, 'nombre', e.target.value)} /></Label></div>
          <div style={{ flex: '1 1 140px', minWidth: 0 }}><Label text={labels[1]}><input style={inputSt} type="tel" value={r.telefono} onChange={e => set(i, 'telefono', e.target.value)} /></Label></div>
          <div style={{ flex: '1 1 160px', minWidth: 0 }}><Label text={labels[2]}><input style={inputSt} value={r.relacion} onChange={e => set(i, 'relacion', e.target.value)} /></Label></div>
          <div style={{ flex: '1.6 1 220px', minWidth: 0 }}><Label text={labels[3]}><input style={inputSt} value={r.direccion} onChange={e => set(i, 'direccion', e.target.value)} /></Label></div>
          <button
            type="button"
            title="Quitar referencia"
            onClick={() => onChange(items.filter((_, j) => j !== i))}
            style={{ flex: '0 0 34px', height: '38px', border: 'none', background: 'none', color: '#9ca3af', cursor: 'pointer', fontSize: '0.95rem', borderRadius: '8px' }}
          >✕</button>
        </div>
      ))}
      <button
        type="button"
        onClick={() => onChange([...items, { ...REF_VACIA }])}
        style={{
          alignSelf: 'flex-start', background: 'none', border: '1.5px dashed #d1d5db', color: '#3b82f6',
          fontWeight: '600', fontSize: '0.85rem', padding: '0.5rem 0.9rem', borderRadius: '8px', cursor: 'pointer',
        }}
      >+ {agregarTxt}</button>
    </div>
  );
}

function Dinero({ value, onChange, inputSt }) {
  return (
    <div style={{ position: 'relative' }}>
      <span style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', fontSize: '0.9rem' }}>$</span>
      <input style={{ ...inputSt, paddingLeft: '1.5rem' }} type="number" min="0" step="0.01" value={value ?? ''} onChange={e => onChange(e.target.value)} />
    </div>
  );
}

// ── Tab "Ficha del cliente" ────────────────────────────────────────────────────
export function PerfilInmobiliario({ perfil, setPerfil, ficha, setFicha, inputSt, Label }) {
  const p  = (k) => (e) => setPerfil(x => ({ ...x, [k]: e.target.value }));
  const f  = (k) => (e) => setFicha(x => ({ ...x, [k]: e.target.value }));
  const fv = (k) => (v) => setFicha(x => ({ ...x, [k]: v }));
  const conConyuge = ESTADOS_CON_CONYUGE.includes(ficha.estado_civil);
  const docs = ficha.documentos || {};
  const entregados = DOCUMENTOS_INMO.filter(d => docs[d.key]).length;

  return (
    <>
      <Seccion first tag="Cliente" color="blue" titulo="Datos personales">
        <div style={gridSt}>
          <Label text="Nombres *"><input style={inputSt} value={perfil.nombres} onChange={p('nombres')} /></Label>
          <Label text="Apellidos *"><input style={inputSt} value={perfil.apellidos} onChange={p('apellidos')} /></Label>
          <Label text="Cédula / RUC"><input style={inputSt} value={perfil.identificacion} onChange={p('identificacion')} /></Label>
          <Label text="Fecha de nacimiento"><input style={inputSt} type="date" value={perfil.fecha_nacimiento} onChange={p('fecha_nacimiento')} /></Label>
          <Label text="Estado civil">
            <select style={inputSt} value={ficha.estado_civil || ''} onChange={f('estado_civil')}>
              <option value="">— Seleccionar —</option>
              <option value="soltero">Soltero/a</option>
              <option value="casado">Casado/a</option>
              <option value="union_hecho">Unión de hecho</option>
              <option value="divorciado">Divorciado/a</option>
              <option value="viudo">Viudo/a</option>
            </select>
          </Label>
          <Label text="WhatsApp"><input style={inputSt} type="tel" value={perfil.whatsapp_number} onChange={p('whatsapp_number')} placeholder="0991234567" /></Label>
          <Label text="Email"><input style={inputSt} type="email" value={perfil.email} onChange={p('email')} placeholder="cliente@email.com" /></Label>
          <Label text="Cargas familiares"><input style={inputSt} type="number" min="0" value={ficha.cargas_familiares ?? ''} onChange={f('cargas_familiares')} /></Label>
          <Label text="Dirección de domicilio"><input style={inputSt} value={perfil.direccion} onChange={p('direccion')} placeholder="Ej: Samanes 5, Mz 912 V 14" /></Label>
          <Label text="Ciudad"><input style={inputSt} value={perfil.ciudad} onChange={p('ciudad')} /></Label>
          <Label text="Vivienda actual">
            <select style={inputSt} value={ficha.vivienda_actual || ''} onChange={f('vivienda_actual')}>
              <option value="">— Seleccionar —</option>
              <option value="arrienda">Arrienda</option>
              <option value="propia">Propia</option>
              <option value="familiar">Familiar</option>
            </select>
          </Label>
        </div>
      </Seccion>

      {conConyuge && (
        <Seccion tag="Cónyuge" color="violet" titulo="Datos del cónyuge">
          <div style={gridSt}>
            <Label text="Nombres y apellidos"><input style={inputSt} value={ficha.conyuge_nombre || ''} onChange={f('conyuge_nombre')} /></Label>
            <Label text="Cédula"><input style={inputSt} value={ficha.conyuge_cedula || ''} onChange={f('conyuge_cedula')} /></Label>
            <Label text="Teléfono"><input style={inputSt} type="tel" value={ficha.conyuge_telefono || ''} onChange={f('conyuge_telefono')} /></Label>
            <Label text="Lugar de trabajo"><input style={inputSt} value={ficha.conyuge_trabajo || ''} onChange={f('conyuge_trabajo')} /></Label>
            <Label text="Ingreso mensual"><Dinero inputSt={inputSt} value={ficha.conyuge_ingreso} onChange={fv('conyuge_ingreso')} /></Label>
          </div>
        </Seccion>
      )}

      <Seccion tag="Laboral" color="green" titulo="Situación laboral y económica" hint="Clave para precalificar crédito">
        <div style={gridSt}>
          <Label text="Situación laboral">
            <select style={inputSt} value={ficha.situacion_laboral || ''} onChange={f('situacion_laboral')}>
              <option value="">— Seleccionar —</option>
              <option value="dependiente">Relación de dependencia</option>
              <option value="independiente">Independiente / negocio propio</option>
              <option value="jubilado">Jubilado/a</option>
              <option value="sin_empleo">Sin empleo</option>
            </select>
          </Label>
          <Label text="Empresa / negocio"><input style={inputSt} value={ficha.empresa || ''} onChange={f('empresa')} /></Label>
          <Label text="Cargo"><input style={inputSt} value={ficha.cargo || ''} onChange={f('cargo')} /></Label>
          <Label text="Antigüedad"><input style={inputSt} value={ficha.antiguedad || ''} onChange={f('antiguedad')} placeholder="Ej: 4 años" /></Label>
          <Label text="Ingreso mensual"><Dinero inputSt={inputSt} value={ficha.ingreso_mensual} onChange={fv('ingreso_mensual')} /></Label>
          <Label text="Afiliado IESS">
            <select style={inputSt} value={ficha.afiliado_iess == null ? '' : String(ficha.afiliado_iess)} onChange={f('afiliado_iess')}>
              <option value="">— Seleccionar —</option>
              <option value="1">Sí</option>
              <option value="0">No</option>
            </select>
          </Label>
          {String(ficha.afiliado_iess) === '1' && (
            <Label text="N.º de aportes IESS"><input style={inputSt} type="number" min="0" value={ficha.aportes_iess ?? ''} onChange={f('aportes_iess')} /></Label>
          )}
          <Label text="Dirección del trabajo"><input style={inputSt} value={ficha.direccion_trabajo || ''} onChange={f('direccion_trabajo')} /></Label>
        </div>
      </Seccion>

      <Seccion tag="Referencias" color="amber" titulo="Referencias personales">
        <Referencias
          items={ficha.referencias_personales || []}
          onChange={fv('referencias_personales')}
          labels={['Nombre completo', 'Teléfono', 'Parentesco / relación', 'Dirección donde vive']}
          agregarTxt="Agregar referencia personal"
          inputSt={inputSt} Label={Label}
        />
      </Seccion>

      <Seccion tag="Referencias" color="amber" titulo="Referencias laborales">
        <Referencias
          items={ficha.referencias_laborales || []}
          onChange={fv('referencias_laborales')}
          labels={['Nombre completo', 'Teléfono', 'Cargo / relación', 'Empresa y lugar de trabajo']}
          agregarTxt="Agregar referencia laboral"
          inputSt={inputSt} Label={Label}
        />
      </Seccion>

      <Seccion tag="Documentos" color="rose" titulo="Documentos entregados" hint={`${entregados} de ${DOCUMENTOS_INMO.length} entregados`}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '0.5rem' }}>
          {DOCUMENTOS_INMO.map(d => {
            const ok = !!docs[d.key];
            return (
              <label key={d.key} style={{
                display: 'flex', alignItems: 'center', gap: '0.55rem', cursor: 'pointer',
                padding: '0.55rem 0.75rem', borderRadius: '8px', fontSize: '0.85rem',
                border: `1px solid ${ok ? '#a7f3d0' : '#e5e7eb'}`,
                background: ok ? '#ecfdf5' : 'transparent', color: ok ? '#047857' : '#374151',
              }}>
                <input
                  type="checkbox" checked={ok}
                  onChange={e => setFicha(x => ({ ...x, documentos: { ...(x.documentos || {}), [d.key]: e.target.checked } }))}
                  style={{ width: '16px', height: '16px', accentColor: '#3b82f6' }}
                />
                {d.label}
              </label>
            );
          })}
        </div>
      </Seccion>

      <Seccion tag="Notas" color="blue" titulo="Observaciones generales">
        <textarea
          style={{ ...inputSt, resize: 'vertical' }} rows={3}
          value={perfil.observaciones_generales}
          onChange={p('observaciones_generales')}
          placeholder="Ej: prefiere que la contacten después de las 17h, visitó el proyecto el sábado..."
        />
      </Seccion>
    </>
  );
}

// ── Tab "Interés inmobiliario" ─────────────────────────────────────────────────
export function InteresInmobiliario({ ficha, setFicha, inputSt, Label }) {
  const f  = (k) => (e) => setFicha(x => ({ ...x, [k]: e.target.value }));
  const fv = (k) => (v) => setFicha(x => ({ ...x, [k]: v }));
  return (
    <Seccion first tag="Interés" color="blue" titulo="¿Qué busca el cliente?">
      <div style={{ ...gridSt, marginBottom: '1rem' }}>
        <Label text="Tipo de inmueble">
          <select style={inputSt} value={ficha.interes_tipo_inmueble || ''} onChange={f('interes_tipo_inmueble')}>
            <option value="">— Seleccionar —</option>
            <option value="casa">Casa</option>
            <option value="departamento">Departamento</option>
            <option value="terreno">Terreno</option>
            <option value="local">Local comercial</option>
            <option value="oficina">Oficina</option>
          </select>
        </Label>
        <Label text="Operación">
          <select style={inputSt} value={ficha.interes_operacion || ''} onChange={f('interes_operacion')}>
            <option value="">— Seleccionar —</option>
            <option value="compra">Compra</option>
            <option value="arriendo">Arriendo</option>
          </select>
        </Label>
        <Label text="Presupuesto"><Dinero inputSt={inputSt} value={ficha.presupuesto} onChange={fv('presupuesto')} /></Label>
        <Label text="Entrada disponible"><Dinero inputSt={inputSt} value={ficha.entrada_disponible} onChange={fv('entrada_disponible')} /></Label>
        <Label text="Forma de pago">
          <select style={inputSt} value={ficha.forma_pago || ''} onChange={f('forma_pago')}>
            <option value="">— Seleccionar —</option>
            <option value="contado">Contado</option>
            <option value="biess">Crédito BIESS</option>
            <option value="banco">Crédito bancario</option>
            <option value="vis_vip">Vivienda de interés social (VIS/VIP)</option>
            <option value="directo">Financiamiento directo</option>
          </select>
        </Label>
        <Label text="Precalificado">
          <select style={inputSt} value={ficha.precalificado == null ? '' : String(ficha.precalificado)} onChange={f('precalificado')}>
            <option value="">— Seleccionar —</option>
            <option value="1">Sí</option>
            <option value="0">No</option>
          </select>
        </Label>
        <Label text="Zona / sector de interés"><input style={inputSt} value={ficha.zona_interes || ''} onChange={f('zona_interes')} placeholder="Ej: Samborondón, vía a la costa" /></Label>
      </div>
      <Label text="Detalles adicionales">
        <textarea
          style={{ ...inputSt, resize: 'vertical' }} rows={3}
          value={ficha.interes_notas || ''}
          onChange={f('interes_notas')}
          placeholder="Ej: 3 habitaciones, patio, cerca de colegios..."
        />
      </Label>
    </Seccion>
  );
}

export const ETIQUETAS_INMO = {
  estado_civil: { soltero: 'Soltero/a', casado: 'Casado/a', union_hecho: 'Unión de hecho', divorciado: 'Divorciado/a', viudo: 'Viudo/a' },
  interes_tipo_inmueble: { casa: 'Casa', departamento: 'Departamento', terreno: 'Terreno', local: 'Local comercial', oficina: 'Oficina' },
  interes_operacion: { compra: 'Compra', arriendo: 'Arriendo' },
  forma_pago: { contado: 'Contado', biess: 'Crédito BIESS', banco: 'Crédito bancario', vis_vip: 'VIS/VIP', directo: 'Financiamiento directo' },
};
